import React from "react";
import { Piano, Guitar, Drum, Mic2, Music4, Wind, Mic, HeartPulse } from "lucide-react";

const iconMap = {
  piano: Piano,
  violin: Music4,
  guitar: Guitar,
  voice: Mic2,
  drums: Drum,
  "alto-saxophone": Wind,
  "ai-voice": Mic,
  "music-therapy": HeartPulse,
};

export const InstrumentIcon = ({ id, className = "h-5 w-5" }) => {
  const Icon = iconMap[id] || Piano;
  return (
    <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-sky-50 text-sky-800">
      <Icon className={className} />
    </span>
  );
};
